export default __webpack_public_path__ + "static/media/MartinPombo.b23f3517.png";